import WalledContent from 'components/Common/WalledContent'
import * as React from 'react'
import { useIntl } from 'react-intl'
import SearchTilePrimaryActionButton from '../shared/SearchTilePrimaryActionButton'
import SearchTileSignUpButton from '../shared/SearchTileSignUpButton'
import TextButton from 'LuxKit/Button/TextButton'
import { getAccommodationSearchPrimaryAction } from 'lib/search/accommodationSearchPresentation'

interface Props {
  offer: App.HotelOffer | App.HotelOfferSummary
  offerMetaData?: App.OfferListMetaData
  onSelectDatesClick?: () => void
  filters?: App.OfferListFilters
  /** Resolved by the tile, so its CTA can't disagree with the price beside it. */
  hidePrice: boolean
  hideMemberWalls?: boolean
  selectDatesOnly?: boolean
}

function HotelSearchTileAction({ offer, offerMetaData, onSelectDatesClick, filters, hidePrice, hideMemberWalls = false, selectDatesOnly = false }: Props) {
  const intl = useIntl()
  const primaryAction = getAccommodationSearchPrimaryAction({
    offerType: offer.type,
    hidePrice,
    isAnytimeSearch: !filters?.checkIn && !filters?.checkOut && !filters?.flexibleNights,
    canSelectDates: !!onSelectDatesClick,
  })

  const handleSelectDatesClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (primaryAction === 'select-dates' && onSelectDatesClick) {
      e.preventDefault()
      onSelectDatesClick()
    }
  }

  const actionButton = primaryAction === 'select-dates' ? (
    <TextButton nonInteractable={!selectDatesOnly} fit={selectDatesOnly ? 'full-width' : 'auto'} kind="primary" onClick={handleSelectDatesClick}>
      {intl.formatMessage({
        id: 'mYW_5ONvelTb6ekAT5XM',
        defaultMessage: 'Select dates',
        description: 'Button text prompting user to select dates on hotel search tile',
      })}
    </TextButton>
  ) : (
    <SearchTilePrimaryActionButton />
  )

  if (selectDatesOnly && primaryAction !== 'select-dates') return null

  return <WalledContent
    offerType={offer.type}
    enforced={!hideMemberWalls && offer.walledGarden}
    wall={<SearchTileSignUpButton />}
  >
    {!offerMetaData?.extendedAvailability && actionButton}
  </WalledContent>
}

export default HotelSearchTileAction
